'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import ListingIconBox from '@/features/listing/components/listing-icon-box/listing-icon-box';
import { DEFAULT_LISTING_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingType } from '@/features/listing/types/listing-types';
import { getCookieCurrentPlace } from '@/features/place/cookies/cookie-current-place';
import placeNameToUrl from '@/features/place/utils/place-name-to-url';
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
interface ListingGridItemProps {
  listingType: ListingType;
}
export default function ListingGridItem(props) {
  const $ = _c(6);
  const {
    listingType
  } = props;
  const router = useRouter();
  let t0;
  if ($[0] !== listingType || $[1] !== router) {
    t0 = () => {
      const currentPlace = getCookieCurrentPlace();
      if (currentPlace) {
        const placeLink = placeNameToUrl(currentPlace.fullName);
        const redirectSearchResultsLink = ROUTER_LINKS.searchResults(DEFAULT_LISTING_PART_VARIANTS[listingType], placeLink);
        router.push(redirectSearchResultsLink);
      }
    };
    $[0] = listingType;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleClickItem = t0;
  let t1;
  if ($[3] !== handleClickItem || $[4] !== listingType) {
    t1 = <ListingIconBox listingType={listingType} onClick={handleClickItem} />;
    $[3] = handleClickItem;
    $[4] = listingType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}